'use client'

import { useState, UIEvent } from 'react'
import ClientExperienceCard from './BlogUsecasesCard/BlogUsecasesCard'
import { Button, Heading, RightArrow } from '@desoutter/uikit'
import { BlogUsecasesBlockFragment } from './BlogUsecasesBlock.generated'
import DatoLink from '@/components/DatoLink/DatoLink'

type BlogUsecasesBlockProps = {
	fragment: BlogUsecasesBlockFragment
}

export default function BlogUsecasesBlock({
	fragment,
}: BlogUsecasesBlockProps) {
	const [positionX, setPositionX] = useState<number>(0)
	const handleScroll = (e: UIEvent<HTMLElement>) => {
		setPositionX(e.currentTarget.scrollLeft)
	}

	return (
		<div
			id={fragment.anchor ? 'spy_' + fragment.anchor.replaceAll(' ', '_') : ''}
			className={fragment.isDark ? 'dark' : ''}
		>
			<div className="py-16 bg-background text-foreground overflow-hidden">
				<div className="container-auto">
					<div className="flex flex-wrap w-full mb-6 lg:mb-12 justify-between items-center">
						<Heading
							as="h2"
							className="mr-4 dark:text-foreground markdown"
							dangerouslySetInnerHTML={{ __html: fragment.title }}
						/>

						<DatoLink fragment={fragment.button}>
							<Button
								name={fragment.button.label}
								size="lg"
								icon={RightArrow}
								title={fragment.button.label}
							>
								{fragment.button.label}
							</Button>
						</DatoLink>
					</div>
				</div>
				<div className="relative" style={{ left: -positionX }}>
					<div className="container-auto flex flex-row pb-6 max-sm:pr-0 sm:gap-6 max-sm:custom-scrollbar max-sm:overflow-x-scroll touch-auto">
						{fragment.clientsExperiences.map((clientExperience) => (
							<ClientExperienceCard
								key={clientExperience.id}
								fragment={clientExperience}
							/>
						))}
					</div>
				</div>
				<div className="max-sm:hidden container-auto cursor-pointer">
					<div
						onScroll={handleScroll}
						className="h-2 custom-scrollbar overflow-x-auto"
					>
						<div style={{ width: fragment.clientsExperiences.length * 437 }} />
					</div>
				</div>
			</div>
		</div>
	)
}
